var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-528 -285)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M542.062 294.438 540.938 294.438C540.319 294.438 539.812 293.931 539.812 293.312L539.812 291.062C539.812 290.444 540.319 289.938 540.938 289.938L542.062 289.938C542.681 289.938 543.188 290.444 543.188 291.062L543.188 293.312C543.188 293.931 542.681 294.438 542.062 294.438Z",
    fill: "#4C39A0",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.5 300.062 543.75 300.062 543.75 298.938 550.5 298.938 550.5 300.062ZM550.5 303.438 543.75 303.438 543.75 302.312 550.5 302.312 550.5 303.438ZM550.5 306.812 543.75 306.812 543.75 305.688 550.5 305.688 550.5 306.812ZM541.5 306.812 532.5 306.812 532.5 304.562C532.5 304.225 532.669 303.888 532.95 303.663 533.569 303.212 534.356 302.819 535.144 302.594 535.763 302.425 536.381 302.312 537 302.312 537.675 302.312 538.294 302.425 538.856 302.594 539.644 302.819 540.431 303.156 541.05 303.663 541.331 303.888 541.5 304.225 541.5 304.562L541.5 306.812ZM537 297.25C538.237 297.25 539.25 298.263 539.25 299.5 539.25 300.737 538.237 301.75 537 301.75 535.763 301.75 534.75 300.737 534.75 299.5 534.75 298.263 535.763 297.25 537 297.25ZM551.625 293.312 544.312 293.312C544.312 294.55 543.3 295.562 542.062 295.562L540.938 295.562C539.7 295.562 538.688 294.55 538.688 293.312L531.375 293.312C530.756 293.312 530.25 293.819 530.25 294.438L530.25 307.938C530.25 308.556 530.756 309.062 531.375 309.062L551.625 309.062C552.244 309.062 552.75 308.556 552.75 307.938L552.75 294.438C552.75 293.819 552.244 293.312 551.625 293.312Z",
    fill: "#4C39A0",
    fillRule: "nonzero",
    fillOpacity: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.d1214670ca6fdaf11d49d4eca5cd1e59.svg";
export { ForwardRef as ReactComponent };